import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormSection from '../formSection';
import localization from 'assets/localization/localization';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Regex from 'services/utils/regex/Regex';
import LabelInput from 'components/sales/Input/labelInput/labelInput';
import { handleValidateObj } from 'constants/objValues/objvalues';

const BilledTo = ({ locationPinCode, pincodeData, handleValue }) => {
  const [isInputError, setIsInputError] = useState({ pinError: false });
  const locationInput = {
    billPinCode: '',
    billGeoCity: '',
    billGeoState: '',
    billGeoCityId: '',
    billGeoStateId: '',
    billPinId: '',
    billAddressLine1: '',
    billAddressLine2: '',
  };
  const [locationData, setlocationData] = useState(locationInput);
  const handlePinBlur = () => {
    if (
      Regex.pinCode.test(locationData.billPinCode) &&
      !isNaN(locationData.billPinCode)
    ) {
      locationPinCode(locationData.billPinCode);
      setIsInputError({ ...isInputError, pinError: '' });
      return false;
    } else {
      setIsInputError({ ...isInputError, pinError: true });
      setlocationData({ ...locationData, billGeoCity: '', billGeoState: '' });
    }
  };
  useEffect(() => {
    if (locationData.billPinCode.length) {
      if (pincodeData.length) {
        let {
          city_name,
          state_name,
          geo_city_id,
          geo_state_id,
          pincode_id,
        } = pincodeData[0];
        setlocationData({
          ...locationData,
          billGeoStateId: geo_state_id,
          billGeoCityId: geo_city_id,
          billGeoCity: city_name,
          billGeoState: state_name,
          billPinId: pincode_id,
        });
      } else {
        setlocationData({ ...locationData, billGeoState: '', billGeoCity: '' });
        alert('pin code is not available');
      }
    }
  }, [pincodeData]);

  useEffect(() => {
    const billObj = {
      billPinCode: locationData.billPinCode,
      billGeoCity: locationData.billGeoCity,
      billGeoState: locationData.billGeoState,
      billGeoCityId: locationData.billGeoCityId,
      billGeoStateId: locationData.billGeoStateId,
      billPinId: locationData.billPinId,
      billAddressLine1: locationData.billAddressLine1,
    };
    const isNotEmpty = handleValidateObj(billObj);
    if (isNotEmpty !== false) {
      handleValue({
        ...billObj,
        billAddressLine2: locationData.billAddressLine2,
      });
    } else {
      handleValue(null);
    }
  }, [locationData]);

  return (
    <FormSection title={localization.billedTo}>
      <LabelInput
        label={localization.pinCode}
        errorMsg={localization.pinError}
        isError={isInputError.pinError}
        inputValue={locationData.billPinCode}
        type="text"
        maxLength={6}
        minLength={4}
        onBlur={handlePinBlur}
        handleChange={(e) =>
          setlocationData({ ...locationData, billPinCode: e.target.value })
        }
        className={locationData.billPinCode.length ? '' : 'empty'}
        required
        isStarRequired={true}
      />
      <ConstantInput
        label={localization.geoState}
        value={locationData.billGeoState}
        disabled
      />
      <ConstantInput
        label={localization.geoCity}
        value={locationData.billGeoCity}
        disabled
      />
      <ConstantInput
        label={localization.addressLine1}
        required
        errorMsg={localization.requiredaddress}
        handleChange={(val) =>
          setlocationData({ ...locationData, billAddressLine1: val })
        }
        isStarRequired={true}
        maxLength={100}
      />
      <ConstantInput
        label={localization.addressLine2}
        handleChange={(val) =>
          setlocationData({ ...locationData, billAddressLine2: val })
        }
        maxLength={50}
      />
    </FormSection>
  );
};

BilledTo.propTypes = {
  locationPinCode: PropTypes.func,
  pincodeData: PropTypes.any,
  handleValue: PropTypes.func,
};

export default BilledTo;
